// InviteScreen.jsx – Einladung als Helfer annehmen oder ablehnen
import React, { useState } from 'react';
import './WelcomeScreen.css';

export function InviteScreen({ invite, currentEmail, onAccept, onDecline, onClose }) {
  const [busy, setBusy] = useState(false);
  const info = invite?.info;
  const error = invite?.error;
  const otherUser = info && currentEmail && currentEmail.toLowerCase() !== info.email.toLowerCase();

  let content;
  if (error) {
    content = (
      <>
        <h2 className="ws-title">Einladung nicht möglich</h2>
        <p className="ws-desc">{error}</p>
        <div className="ws-actions"><button className="ws-btn ws-btn--primary" onClick={onClose}>Schliessen</button></div>
      </>
    );
  } else if (!info) {
    content = <p className="ws-desc">Einladung wird geladen…</p>;
  } else if (info.expired && info.status !== 'accepted') {
    content = (
      <>
        <h2 className="ws-title">Einladung abgelaufen</h2>
        <p className="ws-desc">Diese Einladung ist nicht mehr gültig. Bitte <strong>{info.invitedBy}</strong>, dich erneut einzuladen.</p>
        <div className="ws-actions"><button className="ws-btn ws-btn--primary" onClick={onClose}>Schliessen</button></div>
      </>
    );
  } else {
    content = (
      <>
        <h2 className="ws-title">Einladung zum Mithelfen</h2>
        <p className="ws-desc">
          <strong>{info.invitedBy}</strong> lädt dich ein, beim Stammbaum <strong>„{info.treeName}“</strong> mitzuhelfen.
        </p>
        <div style={{ background: '#f5f7ff', borderRadius: 10, padding: '12px 14px', fontSize: 13, lineHeight: 1.6, color: '#444', marginBottom: 18 }}>
          Wenn du annimmst, kannst du dich mit <strong>{info.email}</strong> einloggen und den Stammbaum mitbearbeiten.
          Du siehst nur diesen Stammbaum und kannst ihn jederzeit wieder verlassen.
          {otherUser && <><br /><br />Du bist zurzeit als <strong>{currentEmail}</strong> eingeloggt. Zum Annehmen wirst du abgemeldet und mit <strong>{info.email}</strong> angemeldet.</>}
          {!currentEmail && <><br /><br />Zum Annehmen erhältst du einen Login-Code an <strong>{info.email}</strong>.</>}
        </div>
        <div className="ws-actions">
          <button className="ws-btn ws-btn--secondary" disabled={busy} onClick={async () => { setBusy(true); await onDecline(); setBusy(false); }}>
            Ablehnen
          </button>
          <button className="ws-btn ws-btn--primary" disabled={busy} onClick={async () => { setBusy(true); await onAccept(); setBusy(false); }}>
            {busy ? 'Einen Moment…' : 'Einladung annehmen'}
          </button>
        </div>
      </>
    );
  }

  return (
    <div className="ws-overlay" style={{ zIndex: 10000 }}>
      <div className="ws-card">
        <div className="ws-logo">Stammbaum-Memo</div>
        <div style={{ height: 12 }} />
        {content}
      </div>
    </div>
  );
}
